if (!customElements.get("variant-swatch-buttons")) {
  customElements.define(
    "variant-swatch-buttons",
    class variantSwatchButtons extends HTMLElement {
      constructor() {
        super();
        this.onColorSwatches();
      }

      onColorSwatches() {
        const variantList = this.getVariantData() || [];
        const swatchButtonList = this.querySelectorAll("color-swatch-variant");
        const result = Object.values(
          variantList.reduce((total, item) => {
            let k = `${item[this.dataset.colorSwatch]}`;
            if (!total[k]) {
              total[k] = { ...item, count: 1 };
            } else {
              total[k].count += 1;
            }
            return total;
          }, {})
        );

        if (swatchButtonList.length > 0) {
          swatchButtonList.forEach((button) => {
            result.forEach((data) => {
              if (data[this.dataset.colorSwatch] === button.dataset.value) {
                // Resolve color: prefer data-swatch-color from Liquid, then normalize, then raw value
                const rawColor = data[this.dataset.colorSwatch];
                const resolvedColor = button.dataset.swatchColor || this.normalizeColor(rawColor);

                if (
                  this.dataset.colorSwatchStyle === "image" &&
                  data.featured_image != null
                ) {
                  const attributes = {
                    style: `--swatch-background-image: url(${data.featured_image.src}); --swatch-background-color: ${resolvedColor};`,
                    "data-variant-id": `${data.id}`,
                  };
                  for (var key in attributes) button.setAttribute(key, attributes[key]);
                } else {
                  const attributes = {
                    style: `--swatch-background-color: ${resolvedColor};`,
                    "data-variant-id": `${data.id}`,
                  };
                  for (var key in attributes) button.setAttribute(key, attributes[key]);
                }
              }
            });
          });
        }
      }

      normalizeColor(value) {
        if (!value) return 'transparent';
        if (this.isValidCSSColor(value)) return value;

        const hyphenated = value.toLowerCase().replace(/\s+/g, '-');
        if (this.isValidCSSColor(hyphenated)) return hyphenated;

        // Try last word: "Sports Grey" → "grey"
        const lastWord = value.split(' ').pop();
        if (this.isValidCSSColor(lastWord)) return lastWord;

        // Try first word: "Sand Dune" → "sand"  
        const firstWord = value.split(' ')[0];
        if (this.isValidCSSColor(firstWord)) return firstWord;

        // Give up — return semi-transparent fallback so swatch still renders
        return 'rgba(0,0,0,0.15)';
      }

      isValidCSSColor(color) {
        const s = new Option().style;
        s.color = color;
        return s.color !== '';
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }
    }
  );
}

if (!customElements.get("color-swatch-variant")) {
  customElements.define(
    "color-swatch-variant",
    class ColorSwatchVariant extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.productHandle = this.dataset.productHandle;
        this.productCard = this.closest(".product-grid-item");

        this.addEventListener("click", this.onClickHandler.bind(this));
      }

      // onClickHandler(event) {
      //   let url = `/products/${this.productHandle}?variant=${this.variantId}&view=bd-colorswatch`;
      //   fetch(url)
      //     .then((response) => response.text())
      //     .then((responseText) => {
      //       const html = new DOMParser().parseFromString(
      //         responseText,
      //         "text/html"
      //       );
      //       this.updateThumbnail(html);
      //       this.updateTitle(html);
      //       this.updatePrice(html);
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     });
      //   // Color swatch button active/remove classList
      //   const colorButtonList = this.productCard.querySelectorAll(
      //     ".product--color-swatch"
      //   );
      //   colorButtonList.forEach((button) => {
      //     button.classList.remove("checked-color");
      //   });
      //   this.classList.add("checked-color");
      // }
      onClickHandler(event) {
        const embroideryValue = this.dataset.embroidery; // set on color-swatch-variant above

        // Find a variant that matches clicked color AND current embroidery
        const variants = JSON.parse(
          this.closest('variant-swatch-buttons').querySelector('script[type="application/json"]').textContent
        );

        const matchedVariant = variants.find((v) => {
          const colorMatch     = v.title.toLowerCase().includes(this.dataset.value.toLowerCase());
          const embroideryMatch = embroideryValue
            ? v.title.toLowerCase().includes(embroideryValue.toLowerCase())
            : true;
          return colorMatch && embroideryMatch;
        });

        if (!matchedVariant) return;

        const url = `/products/${this.dataset.productHandle}?variant=${matchedVariant.id}&view=bd-colorswatch`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateThumbnail(html);
            this.updateTitle(html);
            this.updatePrice(html);
          })
          .catch((e) => console.error(e));

        const colorButtonList = this.productCard.querySelectorAll('.product--color-swatch');
        colorButtonList.forEach((button) => button.classList.remove('checked-color'));
        this.classList.add('checked-color');
      }

      updateThumbnail(html) {
        const destination = this.productCard.querySelector(".media").firstElementChild;
        const source = html.querySelector(".media").firstElementChild;
        if (source && destination) {
          destination.src = source.src;
          destination.srcset = source.srcset;
        }
        // Thumbnail link update
        const linkDestination = this.productCard.querySelector(
          ".full-width-link"
        );
        const linkDestination2 = this.productCard.querySelector(".card__heading-outer a");
        const linkSource = html.querySelector(".product__card--link").getAttribute("href");;

        if (linkDestination && linkSource)
          linkDestination.setAttribute("href", `${linkSource}`);
          linkDestination2.setAttribute("href", `${linkSource}`);
      }

      updateTitle(html) {
        const destination = this.productCard.querySelector(
          ".product-grid-item__title"
        );
        const source = html.querySelector(".product-grid-item__title");

        if (source && destination) destination.innerHTML = source.innerHTML;
      }

      updatePrice(html) {
        const destination = this.productCard.querySelector(".price");
        const source = html.querySelector(".price");
        if (source && destination) destination.innerHTML = source.innerHTML;
      }
    }
  );
}